import React, {Component} from 'react';
 import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
  import config from  '../../../config';
import {dateFormatter, linkFormatter, historyDataFormatter,customFormatter, prepareSelectOptionsList,actionsFormatter, getFieldByPathFormatter} from 'util/Utils';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';
import { ADD_SELECTED_USER_TIME_TRACKING, REMOVE_SELECTED_USER_TIME_TRACKING} from "actions/actionTypes";
import moment from 'moment';
import {Link} from 'react-router';
import HistoryDataModal   from 'shared/HistoryDataModal'
import {convertToHoursAndMinutes } from 'util/Utils';

class AdminUserTimeTrackingTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            currentRecord:{},
            perPage: config.table.numberPerPage,
        };
    }


    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [ ];
            if (_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0) {
                menuItemsMap.push({onClick: (row)=> {
                    this.props.editRecord(row);
                }, label: 'Edit'})
            menuItemsMap.push({onClick: (row)=> {
                this.props.showRemoveDialog(row)
            }, label: 'Delete'})
        }

        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }



    onRowSelect(row, isSelected, e) {
        var actionName =   isSelected ? ADD_SELECTED_USER_TIME_TRACKING : REMOVE_SELECTED_USER_TIME_TRACKING;
        this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        console.log('isSelected',rows );
        var actionName =   isSelected ? ADD_SELECTED_USER_TIME_TRACKING : REMOVE_SELECTED_USER_TIME_TRACKING;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
        if (!_.isUndefined(this.refs.table)) {
            var rowIDs = _.map(this.refs.table.state.data, function (row, key) {
                return row._id;
            });
        }
        var { type, checked, disabled, onChange, rowIndex } = props;

        if (!_.isUndefined(rowIDs) && rowIndex !== 'Header' ){
            checked = _.includes( this.props.adminUsersData.selectedRecords, rowIDs[rowIndex])
        }

        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {

            return (
                <div className='checkbox-personalized'>
                    <CustomTableHeaderCheckbox { ...props }/>
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        } else {
            return (
                <div className='checkbox-personalized'>
                    <input
                        type={ type }
                        name={ 'checkbox' + rowIndex }
                        id={ 'checkbox' + rowIndex }
                        checked={ checked }
                        disabled={ disabled }
                        onChange={ e=> onChange(e, rowIndex) }
                    />
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        }
    }
    workDurationFormatter(cell, row, extra) {
console.log('workDurationFormatter'  );
     return  convertToHoursAndMinutes(moment.duration(row.Duration), {format: 'minutes_in_percentage'})
             //moment.utc(row.Duration).format('HH:mm')

    }

    productsAddedFormatter(cell, row, extra) {
         return <div>{_.map(_.get(row, [ 'ProductsAdded'], []), function (productAdded, key) {
               return  <div  key={key}>
                 <a target="_blank" href={ config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]",  _.get(productAdded, [  'ProductID', 'ShopifyProductID'], '1111111111') ) }>{_.get(productAdded, [  'ProductID', 'ProductName'], 'Not found')}</a>
             </div>
        })}</div>

    }
    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)

        }
          return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.adminUsersData.data} ref='table'
                                 remote={ true }
                                selectRow={selectRowProp }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                 } }

                >
                    <TableHeaderColumn width="40px" dataField='UserID.firstName' dataFormat={ getFieldByPathFormatter }  formatExtraData={ {path:['UserID',  'firstName']}} dataAlign="center"dataSort={true}>First Name</TableHeaderColumn>
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                        hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"
                                       dataSort={true}
                                       dataFormat={(cell, row)=> historyDataFormatter.call(this,row, {field:'ChangeLog'} )}>Log</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='UserID.lastName' dataFormat={ getFieldByPathFormatter }  formatExtraData={ {path:['UserID',  'lastName']}} dataAlign="center"dataSort={true}>Last Name</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='Status' dataAlign="center"
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: 'getObject', format: (row) => {
                            var foundChangeLog =  _.find(_.get(row, 'ChangeLog',[]), item =>{
                                return _.get(item, 'CustomData.PayoutRequestID') || _.get(item, 'CustomData.PaymentRequestID')
                             })
                             if (foundChangeLog) {
                                return <Link className=" underlineText" target="_blank"
                                             to={'/admin/time-tracking-registry?searchText=' + encodeURIComponent(foundChangeLog.CustomData.PayoutRequestID)}>{ _.startCase(row.Status)}</Link>
                            } else {
                                return _.startCase(row.Status)
                            }
                        }
                    }}
                                       dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='ActivityType'  dataFormat={ customFormatter } formatExtraData={ {
                        path: ['ActivityType'], format: (value) => {
                            return _.get(_.find(config.timeTrackingActivityData, item=>{
                                return item.name ==   value
                            }), 'comment','Not found')
                        }
                    }}dataAlign="center"dataSort={true}>Activity</TableHeaderColumn>
                    <TableHeaderColumn width="50px"  dataField="StartTime" dataAlign="center" dataFormat={ dateFormatter }
                                       formatExtraData={ {path:[ 'StartTime'],  'format': 'MM/DD/YYYY HH:mm'} }
                                       dataSort={true}>Started At</TableHeaderColumn>

                    <TableHeaderColumn width="50px"  dataField="EndTime" dataAlign="center" dataFormat={ dateFormatter }
                                       formatExtraData={ {path:[ 'EndTime'],  'format': 'MM/DD/YYYY HH:mm'} }
                                       dataSort={true}>Ended At</TableHeaderColumn>
                    <TableHeaderColumn width="50px"  dataField="ProductsAdded" dataAlign="center"
                                       dataFormat={(cell, row, extra)=>{
                                            if(_.size(_.filter(_.get(row, 'ProductsAdded',[]), item=>{
                                                              return item.ProductID
                                                    }))>0){
                                               return linkFormatter(cell, row, extra)
                                           }
                                       } }
                                       formatExtraData={ {
                                           getLabel: (row)=>{
                                               return  _.size(_.get(row,'ProductsAdded',[]))
                                           },
                                           path: 'getObject',
                                           formatPathValue:(row)=>{
                                                var recordIDs = _.map(_.filter(_.get(row, 'ProductsAdded',[]), item=>{
                                                    return item.ProductID
                                                }), item=>{
                                                   return  'recordIDs='+ encodeURIComponent(item.ProductID)
                                               })
                                                return      recordIDs.join('&')
                                           },
                                           placeholder: '[queryParams]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/products?[queryParams]',
                                       }  }
                                       dataSort={true}>Products</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataField="Duration" dataFormat={this.workDurationFormatter} dataAlign="center"dataSort={true}>Duration</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='Comment'  dataAlign="center"   dataFormat={ customFormatter }
                                       formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                           var Comment = _.get(row, 'Comment','')
                                           var changeLogFound = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
                                               return _.get(changeLog, 'FieldChanged', '') == 'Comment'
                                           })

                                           return <div>
                                               {Comment}
                                               <div className="font-size-15 orange">{changeLogFound? 'Edited':''}</div>
                                           </div>
                                       }
                                       }}

                                       dataSort={true}>Comment</TableHeaderColumn>

                    {/*<TableHeaderColumn width="80px"  dataFormat={this.productsAddedFormatter}  dataAlign="center"dataSort={true}>Products Added</TableHeaderColumn>*/}

                    <TableHeaderColumn width="30px" dataAlign="center"  columnClassName={'actions-column'}
                                       dataFormat={ this.customActionsFormatter.bind(this)  }>Actions</TableHeaderColumn>
                </BootstrapTable>
                <HistoryDataModal data={this.state.currentRecord} hideModal={ ()=>{
                        this.setState({currentRecord: {}, historyDataModalVisible: false});
                 }}
                                  show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>
        );
    }
}


export default AdminUserTimeTrackingTable;
